import { createReducer } from 'redux-act';
import Immutable from 'seamless-immutable';
import _ from 'lodash';

import WinnerActions from '../winner-actions';

const initialState = Immutable({
  drawsById:       {},
  winnersById:     {},
  winnersByDrawId: {},
  isFetching:      false,
  hasFetched:      false,
});

const reducer = createReducer((on) => {
  on(WinnerActions.fetch, (state) => state.set('isFetching', true));
  on(WinnerActions.fetchFailure, (state) => state.merge({ isFetching: false, hasFetched: true }));
  on(WinnerActions.fetchSuccess, (state, { draws }) => {
    const winnersById = {},
      drawsById = {},
      winnersByDrawId = {};

    _.reduce(
      draws,
      (accDraws, draw, key) => {
        const _drawWinners = [];
        _.reduce(
          draw.places,
          (accWinners, winner, key) => {
            accWinners[winner.id] = winner;
            _drawWinners.push(winner.id);
            return accWinners;
          },
          winnersById
        );
        winnersByDrawId[draw.id] = _drawWinners;
        // remove places from the draw - we already have an idex of winners
        accDraws[draw.id] = _.omit(draw, 'places');
        return accDraws;
      },
      drawsById
    );

    return state.merge({ isFetching: false, hasFetched: true, drawsById, winnersById, winnersByDrawId });
  });

  on(WinnerActions.updateDrawSuccess, (state, { id, draw }) => {
    const _currentWinners = _.values(state.winnersById);

    // get all the winner ids from the shuffled draw
    const _winnerIdsInDraw = _.reduce(
      draw.places,
      (accPlaces, place) => {
        accPlaces.push(place.id);
        return accPlaces;
      },
      []
    );

    let _winners = _.reject(_.values(_currentWinners), (winner) => _.includes(_winnerIdsInDraw, winner.id));

    // add the new winners
    _winners = _winners.concat(draw.places);

    // _winners array back out to an object
    const _winnersById = _.keyBy(_winners, 'id');

    return state
      .setIn(['drawsById', draw.id], _.omit(draw, 'places'))
      .setIn(['winnersByDrawId', draw.id], _winnerIdsInDraw)
      .set('winnersById', _winnersById);
  });

  on(WinnerActions.updateWinnerSuccess, (state, { winner }) => {
    const _winner = state.winnersById[winner.id].merge(winner, { deep: true });
    return state.setIn(['winnersById', winner.id], _winner);
  });

  on(WinnerActions.reselectWinnerSuccess, (state, { winner, drawId, prevWinnerId }) => {
    const _winnersForDraw = state.winnersByDrawId[drawId].concat([winner.id]);

    // we no longer get the whole draw back so we have to update the previous winner in order to archive it
    const _updatePrevWinner = state.winnersById[prevWinnerId].merge({
      archived: true,
      place:    'archive',
    });

    return state
      .setIn(['winnersById', prevWinnerId], _updatePrevWinner)
      .setIn(['winnersById', winner.id], winner)
      .setIn(['winnersByDrawId', drawId], _winnersForDraw);
  });
}, initialState);

export default reducer;
